module.exports = __webpack_public_path__ + "static/img/avatar.c6e5606e.png";